/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { supabase } from './supabase'
import { uploadToR2 } from './r2'

const FAMILY_MEMBERS = [
  { email: 'kkdbailey@gmail.com', name: 'Kevin', color: '#e94560' },
  { email: 'moniquebailey1026@gmail.com', name: 'Monique', color: '#5856d6' },
  { email: 'natashabbhatt@gmail.com', name: 'Tasha', color: '#ff9f0a' },
  { email: 'karahauswirth@gmail.com', name: 'Kara', color: '#30d158' },
  { email: 'perniel.grace19@gmail.com', name: 'Grace', color: '#64d2ff' },
  { email: 'mtraetin@gmail.com', name: 'Traetin', color: '#bf5af2' },
  { email: 'ravibhatt150@gmail.com', name: 'Ravi', color: '#ff6b6b' },
]

const REACTION_EMOJIS = ['❤️','😂','😮','😢','😡','👍','🔥','🎉','👏','💪','😍','🙏','✨','🥰','😎','🤣','💯','🫶','👀','🤩']
const CHAT_EMOJIS = [
  '😀','😂','🥰','😍','🤩','😎','🥳','😅','😊','🙂','😏','😒','😔','😭','😤','🤔',
  '👍','👎','❤️','🔥','💯','✨','🎉','👏','🙏','💪','🫶','👀','😘','🤗',
  '😴','🤣','😆','😋','🤤','😜','🤪','🥹','☺️','😌','🫠','🤭','🫡','🥺',
]
const GIPHY_KEY = 'fzXKHjSelkSCAWQkLzuTqIxgr5Laramg'

const S = {
  h1: { fontSize: '22px', fontWeight: '700', color: 'var(--text-primary)', letterSpacing: '-0.4px', margin: 0 },
  label: { fontSize: '12px', color: 'var(--text-tertiary)' },
  body: { fontSize: '15px', color: 'var(--text-primary)', lineHeight: 1.5 },
  caption: { fontSize: '11px', color: 'var(--text-hint)' },
  touchBtn: {
    minHeight: '44px', minWidth: '44px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: 'none', background: 'transparent', cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
  },
  card: {
    background: 'var(--bg-card)', borderRadius: '16px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.07)', marginBottom: '10px', overflow: 'hidden',
  },
  input: {
    fontSize: '16px', fontFamily: 'inherit',
    border: '1.5px solid var(--border)', borderRadius: '22px',
    padding: '11px 16px', outline: 'none',
    background: 'var(--bg-input)', color: 'var(--text-primary)',
    WebkitAppearance: 'none',
  },
  textarea: {
    fontSize: '16px', fontFamily: 'inherit',
    border: '1.5px solid var(--border)', borderRadius: '12px',
    padding: '11px 14px', outline: 'none', resize: 'none',
    background: 'var(--bg-input)', color: 'var(--text-primary)',
    width: '100%', boxSizing: 'border-box',
    WebkitAppearance: 'none',
  },
}

function getMember(email) {
  const lower = email?.toLowerCase()
  return FAMILY_MEMBERS.find(m => m.email.toLowerCase() === lower) || { name: email?.split('@')[0] || 'Unknown', color: 'var(--text-tertiary)' }
}
function displayName(email) { return getMember(email).name }

function timeAgo(ts) {
  const diff = (Date.now() - new Date(ts)) / 1000
  if (diff < 60) return 'just now'
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`
  return new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

function fullTime(ts) {
  return new Date(ts).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

function PostSkeleton() {
  return (
    <div style={{ ...S.card, padding: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'var(--bg-tertiary)', flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <div style={{ width: '90px', height: '13px', background: 'var(--bg-tertiary)', borderRadius: '6px', marginBottom: '7px' }} />
          <div style={{ width: '55px', height: '11px', background: 'var(--bg-tertiary)', borderRadius: '6px' }} />
        </div>
      </div>
      <div style={{ width: '100%', height: '13px', background: 'var(--bg-tertiary)', borderRadius: '6px', marginBottom: '8px' }} />
      <div style={{ width: '65%', height: '13px', background: 'var(--bg-tertiary)', borderRadius: '6px' }} />
    </div>
  )
}

function MemberAvatar({ email, size = 40 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: getMember(email).color,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'white', fontWeight: '700', fontSize: Math.round(size * 0.4) + 'px',
      flexShrink: 0,
    }}>
      {displayName(email).charAt(0)}
    </div>
  )
}

// ─── INBOX VIEW ───────────────────────────────────────────────────────────────
function MessagesInbox({ userEmail, allMessages, onSelectContact, onNewMessage }) {
  const normalizedEmail = userEmail.toLowerCase()
  const contacts = FAMILY_MEMBERS.filter(m => m.email.toLowerCase() !== normalizedEmail)

  // Build a conversation summary per contact
  const conversations = contacts.map(contact => {
    const contactEmail = contact.email.toLowerCase()
    const thread = allMessages.filter(m => {
      const s = m.sender_email?.toLowerCase()
      const r = m.recipient_email?.toLowerCase()
      return (s === normalizedEmail && r === contactEmail) ||
             (s === contactEmail && r === normalizedEmail)
    })
    const last = thread[thread.length - 1] || null
    const unread = thread.filter(m =>
      m.sender_email?.toLowerCase() === contactEmail && !m.read_at
    ).length
    return { contact, last, unread, hasMessages: thread.length > 0 }
  })

  // Sort: conversations with messages first (most recent), then alphabetical
  const sorted = [...conversations].sort((a, b) => {
    if (a.last && b.last) return new Date(b.last.created_at) - new Date(a.last.created_at)
    if (a.last) return -1
    if (b.last) return 1
    return a.contact.name.localeCompare(b.contact.name)
  })

  const totalUnread = conversations.reduce((sum, c) => sum + c.unread, 0)

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h1 style={S.h1}>Messages</h1>
          {totalUnread > 0 && (
            <span style={{ background: '#e94560', color: 'white', borderRadius: '12px', fontSize: '12px', fontWeight: '700', padding: '2px 8px' }}>{totalUnread}</span>
          )}
        </div>
        <button
          onClick={onNewMessage}
          style={{ ...S.touchBtn, minWidth: 'unset', padding: '0 16px', borderRadius: '20px', background: '#e94560', color: 'white', fontSize: '14px', fontWeight: '600', gap: '5px' }}
        >
          ✏️ New
        </button>
      </div>

      {/* Conversation list */}
      <div style={{ background: 'var(--bg-card)', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
        {sorted.map((item, idx) => {
          const { contact, last, unread } = item
          const isLast = idx === sorted.length - 1
          const preview = last
            ? last.photo_url
              ? '📷 Photo'
              : last.content || ''
            : 'No messages yet'
          const isFromMe = last?.sender_email?.toLowerCase() === normalizedEmail

          return (
            <div
              key={contact.email}
              onClick={() => onSelectContact(contact)}
              style={{
                display: 'flex', alignItems: 'center', gap: '12px',
                padding: '12px 16px',
                borderBottom: isLast ? 'none' : '1px solid var(--border-light)',
                cursor: 'pointer',
                background: 'transparent',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <MemberAvatar email={contact.email} size={50} />
                {unread > 0 && (
                  <div style={{
                    position: 'absolute', bottom: 0, right: 0,
                    width: '16px', height: '16px', borderRadius: '50%',
                    background: '#e94560', border: '2px solid var(--bg-card)',
                  }} />
                )}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '3px' }}>
                  <p style={{ fontSize: '16px', fontWeight: unread > 0 ? '700' : '600', color: 'var(--text-primary)', margin: 0 }}>{contact.name}</p>
                  {last && <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', flexShrink: 0, marginLeft: '8px' }}>{timeAgo(last.created_at)}</p>}
                </div>
                <p style={{
                  fontSize: '14px',
                  color: unread > 0 ? 'var(--text-primary)' : 'var(--text-tertiary)',
                  fontWeight: unread > 0 ? '500' : '400',
                  margin: 0,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {isFromMe && last ? `You: ${preview}` : preview}
                </p>
              </div>
              <span style={{ fontSize: '18px', color: 'var(--text-tertiary)', flexShrink: 0 }}>›</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// ─── NEW MESSAGE CONTACT PICKER ───────────────────────────────────────────────
function NewMessagePicker({ userEmail, onSelect, onBack }) {
  const contacts = FAMILY_MEMBERS.filter(m => m.email.toLowerCase() !== userEmail.toLowerCase())
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <button onClick={onBack} style={{ ...S.touchBtn, minWidth: 'unset', padding: '0 8px', fontSize: '16px', color: '#e94560', fontWeight: '600' }}>‹ Back</button>
        <h1 style={S.h1}>New Message</h1>
      </div>
      <p style={{ fontSize: '14px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>Select a family member</p>
      <div style={{ background: 'var(--bg-card)', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
        {contacts.map((contact, idx) => (
          <div
            key={contact.email}
            onClick={() => onSelect(contact)}
            style={{
              display: 'flex', alignItems: 'center', gap: '12px',
              padding: '12px 16px',
              borderBottom: idx < contacts.length - 1 ? '1px solid var(--border-light)' : 'none',
              cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <MemberAvatar email={contact.email} size={44} />
            <p style={{ fontSize: '16px', fontWeight: '600', color: 'var(--text-primary)', margin: 0 }}>{contact.name}</p>
            <span style={{ fontSize: '18px', color: 'var(--text-tertiary)', marginLeft: 'auto' }}>›</span>
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── CONVERSATION VIEW ────────────────────────────────────────────────────────
function ConversationView({
  userEmail, recipient, allMessages,
  onBack, onFetchMessages,
  recipientTyping,
}) {
  const normalizedEmail = userEmail.toLowerCase()
  const [chatInput, setChatInput] = useState('')
  const [sending, setSending] = useState(false)
  const [showChatEmoji, setShowChatEmoji] = useState(false)
  const [tappedMsg, setTappedMsg] = useState(null)
  const [showMsgReactions, setShowMsgReactions] = useState(null)
  const [showGifPicker, setShowGifPicker] = useState(false)
  const [gifSearch, setGifSearch] = useState('')
  const [gifs, setGifs] = useState([])
  const [gifLoading, setGifLoading] = useState(false)
  const [lightboxPhoto, setLightboxPhoto] = useState(null)
  const [keyboardHeight, setKeyboardHeight] = useState(0)
  const messagesEndRef = useRef()
  const chatInputRef = useRef()
  const chatPhotoInputRef = useRef()
  const longPressTimer = useRef(null)

  const threadMessages = allMessages.filter(m => {
    const s = m.sender_email?.toLowerCase()
    const r = m.recipient_email?.toLowerCase()
    const recip = recipient.email.toLowerCase()
    return (s === normalizedEmail && r === recip) ||
           (s === recip && r === normalizedEmail)
  })

  useEffect(() => {
    function handleViewport() {
      if (window.visualViewport) {
        const kbHeight = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop
        setKeyboardHeight(Math.max(0, kbHeight))
      }
    }
    window.visualViewport?.addEventListener('resize', handleViewport)
    window.visualViewport?.addEventListener('scroll', handleViewport)
    return () => {
      window.visualViewport?.removeEventListener('resize', handleViewport)
      window.visualViewport?.removeEventListener('scroll', handleViewport)
    }
  }, [])

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [threadMessages.length])

  // Mark unread messages as read when conversation opens or new messages arrive
  useEffect(() => {
    if (threadMessages.length === 0) return
    const unread = threadMessages.filter(m =>
      m.sender_email?.toLowerCase() === recipient.email.toLowerCase() && !m.read_at
    )
    if (unread.length > 0) {
      const ids = unread.map(m => m.id)
      supabase.from('messages').update({ read_at: new Date().toISOString() }).in('id', ids).then(() => onFetchMessages())
    }
  }, [threadMessages.length, recipient.email])

  useEffect(() => {
    function handle() { setShowChatEmoji(false) }
    document.addEventListener('click', handle)
    return () => document.removeEventListener('click', handle)
  }, [])

  async function sendMessage() {
    if (!chatInput.trim()) return
    setSending(true)
    await supabase.from('messages').insert([{ sender_email: userEmail, recipient_email: recipient.email, content: chatInput.trim() }])
    setChatInput(''); setSending(false); setShowChatEmoji(false); onFetchMessages()
  }

  async function deleteMessage(msgId) {
    if (!window.confirm('Delete this message?')) return
    await supabase.from('messages').delete().eq('id', msgId)
    setTappedMsg(null); onFetchMessages()
  }

  async function sendChatPhoto(file) {
    if (!file) return
    try {
      const ext = file.name.split('.').pop()
      const path = `chat/${Date.now()}.${ext}`
      const photo_url = await uploadToR2(file, path)
      await supabase.from('messages').insert([{ sender_email: userEmail, recipient_email: recipient.email, content: '', photo_url }])
      onFetchMessages()
    } catch (err) { console.error('Chat photo upload failed:', err) }
  }

  async function addMsgReaction(msgId, emoji) {
    const msg = threadMessages.find(m => m.id === msgId)
    if (!msg) return
    const reactions = msg.reactions || []
    const existing = reactions.find(r => r.email === userEmail)
    let updated
    if (existing?.emoji === emoji) {
      updated = reactions.filter(r => r.email !== userEmail)
    } else {
      updated = [...reactions.filter(r => r.email !== userEmail), { email: userEmail, emoji }]
    }
    await supabase.from('messages').update({ reactions: updated }).eq('id', msgId)
    setShowMsgReactions(null); onFetchMessages()
  }

  function broadcastTyping() {
    if (!userEmail || userEmail === 'local') return
    const channelName = `typing_${[userEmail, recipient.email].sort().join('_')}`
    supabase.channel(channelName).send({ type: 'broadcast', event: 'typing', payload: { email: userEmail } })
  }

  function handleChatInputChange(e) { setChatInput(e.target.value); broadcastTyping() }
  function insertEmoji(emoji) { setChatInput(prev => prev + emoji); chatInputRef.current?.focus() }
  function handleLongPressStart(msgId) {
    longPressTimer.current = setTimeout(() => {
      setShowMsgReactions(msgId)
      if (navigator.vibrate) navigator.vibrate(30)
    }, 500)
  }
  function handleLongPressEnd() { clearTimeout(longPressTimer.current) }

  async function searchGifs(query) {
    if (!query.trim()) { setGifs([]); return }
    setGifLoading(true)
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_KEY}&q=${encodeURIComponent(query)}&limit=20&rating=g`)
      const data = await res.json()
      setGifs(data.data || [])
    } catch { setGifs([]) }
    setGifLoading(false)
  }

  async function loadTrendingGifs() {
    setGifLoading(true)
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${GIPHY_KEY}&limit=20&rating=g`)
      const data = await res.json()
      setGifs(data.data || [])
    } catch { setGifs([]) }
    setGifLoading(false)
  }

  // Build date-grouped message list
  const groups = []
  let currentDate = null
  threadMessages.forEach((msg, i) => {
    const d = new Date(msg.created_at).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
    if (d !== currentDate) { groups.push({ type: 'date', label: d, key: `d${i}` }); currentDate = d }
    groups.push({ type: 'msg', msg, i })
  })

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: `calc(100dvh - 160px - ${keyboardHeight}px)`, minHeight: '400px' }}>

      {/* Lightbox */}
      {lightboxPhoto && (
        <div onClick={() => setLightboxPhoto(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.94)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <img src={lightboxPhoto} alt="full" style={{ maxWidth: '100%', maxHeight: '88vh', borderRadius: '10px', objectFit: 'contain' }} />
          <button onClick={() => setLightboxPhoto(null)} style={{ ...S.touchBtn, position: 'absolute', top: 'max(20px,env(safe-area-inset-top,20px))', right: '16px', width: '44px', height: '44px', background: 'rgba(255,255,255,0.18)', borderRadius: '50%', color: 'white', fontSize: '22px' }}>×</button>
        </div>
      )}

      {/* GIF Picker */}
      {showGifPicker && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }} onClick={() => setShowGifPicker(false)}>
          <div style={{ background: 'var(--bg-card)', borderRadius: '20px 20px 0 0', width: '100%', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div style={{ padding: '16px 16px 10px', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input placeholder="Search GIFs..." value={gifSearch} onChange={e => { setGifSearch(e.target.value); searchGifs(e.target.value) }} style={{ ...S.input, flex: 1 }} autoFocus />
              <button onClick={() => setShowGifPicker(false)} style={{ ...S.touchBtn, width: '36px', height: '36px', minWidth: '36px', background: 'var(--bg-tertiary)', borderRadius: '50%', fontSize: '18px', color: 'var(--text-secondary)' }}>×</button>
            </div>
            <div style={{ overflowY: 'auto', padding: '10px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
              {gifLoading && <p style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text-tertiary)', padding: '20px' }}>Loading...</p>}
              {!gifLoading && gifs.length === 0 && <p style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text-tertiary)', padding: '20px' }}>No GIFs found</p>}
              {gifs.map(gif => (
                <img key={gif.id} src={gif.images.fixed_height_small.url} alt={gif.title}
                  onClick={() => {
                    const url = gif.images.downsized.url
                    supabase.from('messages').insert([{ sender_email: userEmail, recipient_email: recipient.email, content: '', photo_url: url }]).then(() => onFetchMessages())
                    setShowGifPicker(false)
                  }}
                  style={{ width: '100%', borderRadius: '8px', cursor: 'pointer', aspectRatio: '4/3', objectFit: 'cover' }}
                />
              ))}
            </div>
            <p style={{ textAlign: 'center', fontSize: '11px', color: '#c7c7cc', padding: '8px', borderTop: '1px solid var(--border-light)' }}>Powered by GIPHY</p>
          </div>
        </div>
      )}

      {/* Conversation header */}
      <div style={{ background: 'var(--bg-card)', borderBottom: '1px solid var(--border-light)', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
        <button onClick={onBack} style={{ ...S.touchBtn, minWidth: 'unset', padding: '0 8px', fontSize: '22px', color: '#e94560' }}>‹</button>
        <MemberAvatar email={recipient.email} size={36} />
        <div>
          <p style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text-primary)', lineHeight: 1.2, margin: 0 }}>{recipient.name}</p>
          <p style={{ fontSize: '11px', color: '#34c759', margin: 0 }}>● private</p>
        </div>
      </div>

      {/* Messages scroll area */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0 4px', display: 'flex', flexDirection: 'column', WebkitOverflowScrolling: 'touch' }}>
        {threadMessages.length === 0 && (
          <div style={{ margin: 'auto', textAlign: 'center', padding: '32px 24px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}><MemberAvatar email={recipient.email} size={56} /></div>
            <p style={{ fontSize: '16px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '4px', margin: '0 0 4px' }}>{recipient.name}</p>
            <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>Start a private conversation</p>
          </div>
        )}

        {groups.map(item => {
          if (item.type === 'date') {
            return (
              <div key={item.key} style={{ textAlign: 'center', margin: '12px 0 4px' }}>
                <span style={{ fontSize: '12px', color: 'var(--text-tertiary)', fontWeight: '500' }}>{item.label}</span>
              </div>
            )
          }
          const { msg, i } = item
          const isMe = msg.sender_email?.toLowerCase() === normalizedEmail
          const isTapped = tappedMsg === msg.id
          const isLast = i === threadMessages.length - 1
          const next = threadMessages[i + 1]
          const sameAsNext = next?.sender_email?.toLowerCase() === msg.sender_email?.toLowerCase()
          const sameAsPrev = i > 0 && threadMessages[i - 1]?.sender_email?.toLowerCase() === msg.sender_email?.toLowerCase()
          const br = isMe
            ? `18px ${sameAsPrev ? '18px' : '18px'} ${sameAsNext ? '4px' : '18px'} 4px`
            : `${sameAsPrev ? '18px' : '18px'} 18px 4px ${sameAsNext ? '4px' : '18px'}`
          const msgReactions = msg.reactions || []
          const isRead = isMe && msg.read_at

          return (
            <div key={msg.id} style={{ marginBottom: sameAsNext ? '2px' : '8px', position: 'relative' }}>
              {showMsgReactions === msg.id && (
                <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', [isMe ? 'right' : 'left']: '10px', bottom: '100%', background: 'var(--bg-card)', borderRadius: '22px', padding: '6px 8px', boxShadow: '0 4px 20px rgba(0,0,0,0.18)', display: 'flex', gap: '2px', zIndex: 300, marginBottom: '6px' }}>
                  {['❤️','😂','😮','👍','🔥','😢'].map(emoji => (
                    <button key={emoji} onClick={() => addMsgReaction(msg.id, emoji)} style={{ ...S.touchBtn, width: '42px', height: '42px', minWidth: '42px', fontSize: '24px', borderRadius: '50%', background: msgReactions.find(r => r.email === userEmail)?.emoji === emoji ? 'var(--bg-tertiary)' : 'transparent' }}>{emoji}</button>
                  ))}
                </div>
              )}
              <div
                style={{ display: 'flex', flexDirection: 'column', alignItems: isMe ? 'flex-end' : 'flex-start', padding: '0 10px' }}
                onClick={() => { setTappedMsg(isTapped ? null : msg.id); setShowMsgReactions(null) }}
                onTouchStart={() => handleLongPressStart(msg.id)}
                onTouchEnd={handleLongPressEnd}
                onTouchMove={handleLongPressEnd}
                onMouseDown={() => handleLongPressStart(msg.id)}
                onMouseUp={handleLongPressEnd}
                onMouseLeave={handleLongPressEnd}
              >
                {msg.photo_url ? (
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img src={msg.photo_url} alt="chat" onClick={e => { e.stopPropagation(); setLightboxPhoto(msg.photo_url) }} style={{ maxWidth: '210px', borderRadius: '16px', cursor: 'pointer', display: 'block', border: '1px solid rgba(0,0,0,0.05)' }} />
                    {isTapped && isMe && (
                      <button onClick={e => { e.stopPropagation(); deleteMessage(msg.id) }} style={{ position: 'absolute', top: '6px', right: '6px', background: 'rgba(0,0,0,0.55)', border: 'none', borderRadius: '50%', width: '28px', height: '28px', color: 'white', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                    )}
                  </div>
                ) : (
                  <div style={{ maxWidth: '78%', background: isMe ? '#30d158' : 'var(--bg-card)', color: isMe ? 'white' : 'var(--text-primary)', borderRadius: br, padding: '9px 13px', fontSize: '16px', lineHeight: 1.4, boxShadow: isMe ? '0 1px 4px rgba(48,209,88,0.3)' : '0 1px 3px rgba(0,0,0,0.09)', wordBreak: 'break-word' }}>
                    {msg.content}
                  </div>
                )}
                {msgReactions.length > 0 && (
                  <div style={{ display: 'flex', gap: '3px', marginTop: '3px' }}>
                    {msgReactions.map((r, ri) => (
                      <span key={ri} style={{ fontSize: '15px', background: 'var(--bg-card)', borderRadius: '12px', padding: '2px 6px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>{r.emoji}</span>
                    ))}
                  </div>
                )}
                {(isTapped || isLast) && (
                  <p style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '4px', padding: '0 3px' }}>
                    {isLast && isMe ? (isRead ? '✓✓ Read · ' : 'Delivered · ') : ''}{fullTime(msg.created_at)}
                  </p>
                )}
                {isTapped && isMe && !msg.photo_url && (
                  <button onClick={e => { e.stopPropagation(); deleteMessage(msg.id) }} style={{ ...S.touchBtn, minHeight: '32px', fontSize: '13px', color: '#ff3b30', padding: '0 3px' }}>Delete</button>
                )}
              </div>
            </div>
          )
        })}

        {recipientTyping && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '2px 14px 8px' }}>
            <MemberAvatar email={recipient.email} size={22} />
            <div style={{ background: 'var(--bg-card)', borderRadius: '16px 16px 16px 4px', padding: '9px 13px', boxShadow: '0 1px 3px rgba(0,0,0,0.09)', display: 'flex', gap: '3px', alignItems: 'center' }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#c7c7cc', animation: 'typing 1.2s infinite', animationDelay: '0s', display: 'inline-block' }} />
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#c7c7cc', animation: 'typing 1.2s infinite', animationDelay: '0.2s', display: 'inline-block' }} />
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#c7c7cc', animation: 'typing 1.2s infinite', animationDelay: '0.4s', display: 'inline-block' }} />
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Input bar */}
      <div style={{ background: 'var(--bg-card)', borderTop: '1px solid var(--border)', padding: '8px 10px', paddingBottom: 'max(8px,env(safe-area-inset-bottom,8px))', position: 'relative', flexShrink: 0 }}>
        {showChatEmoji && (
          <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: 'var(--bg-card)', borderTop: '1px solid var(--border-light)', padding: '6px 8px', display: 'flex', flexWrap: 'wrap', maxHeight: '150px', overflowY: 'auto', zIndex: 100 }}>
            {CHAT_EMOJIS.map(emoji => (
              <button key={emoji} onClick={() => insertEmoji(emoji)} style={{ ...S.touchBtn, width: '44px', height: '44px', minWidth: '44px', fontSize: '24px', borderRadius: '8px' }}>{emoji}</button>
            ))}
          </div>
        )}
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <button onClick={e => { e.stopPropagation(); setShowChatEmoji(!showChatEmoji) }} style={{ ...S.touchBtn, width: '36px', height: '36px', minWidth: '36px', background: 'var(--bg-tertiary)', borderRadius: '50%', fontSize: '19px', flexShrink: 0 }}>😊</button>
          {!chatInput.trim() && (
            <>
              <button onClick={() => chatPhotoInputRef.current.click()} style={{ ...S.touchBtn, width: '36px', height: '36px', minWidth: '36px', background: 'var(--bg-tertiary)', borderRadius: '50%', fontSize: '17px', flexShrink: 0 }}>📷</button>
              <input ref={chatPhotoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => { if (e.target.files[0]) sendChatPhoto(e.target.files[0]) }} />
              <button onClick={() => { setShowGifPicker(true); loadTrendingGifs(); setGifSearch('') }} style={{ ...S.touchBtn, width: '36px', height: '36px', minWidth: '36px', background: 'var(--bg-tertiary)', borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: 'var(--text-secondary)', flexShrink: 0 }}>GIF</button>
            </>
          )}
          <div style={{ flex: 1, border: `1.5px solid ${chatInput.trim() ? '#30d158' : 'var(--border)'}`, borderRadius: '22px', background: 'var(--bg-input)', display: 'flex', alignItems: 'center', minWidth: 0, transition: 'border-color 0.2s' }}>
            <input ref={chatInputRef} placeholder="iMessage" value={chatInput} onChange={handleChatInputChange} onKeyDown={e => e.key === 'Enter' && !e.shiftKey && sendMessage()} style={{ flex: 1, border: 'none', background: 'transparent', padding: '10px 12px', fontSize: '16px', fontFamily: 'inherit', outline: 'none', minWidth: 0, color: 'var(--text-primary)' }} />
            {chatInput.trim() && (
              <button onClick={sendMessage} disabled={sending} style={{ ...S.touchBtn, width: '32px', height: '32px', minWidth: '32px', borderRadius: '50%', background: '#30d158', color: 'white', fontSize: '16px', marginRight: '3px', flexShrink: 0 }}>↑</button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── MAIN SOCIAL COMPONENT ────────────────────────────────────────────────────
export default function Social() {
  const [activeTab, setActiveTab] = useState('feed')
  const [userEmail, setUserEmail] = useState('local')

  // Feed state
  const [posts, setPosts] = useState([])
  const [feedLoading, setFeedLoading] = useState(true)
  const [postText, setPostText] = useState('')
  const [postPhoto, setPostPhoto] = useState(null)
  const [postPhotoPreview, setPostPhotoPreview] = useState(null)
  const [postGif, setPostGif] = useState(null)
  const [showGifPicker, setShowGifPicker] = useState(null)
  const [gifSearch, setGifSearch] = useState('')
  const [gifs, setGifs] = useState([])
  const [gifLoading, setGifLoading] = useState(false)
  const [posting, setPosting] = useState(false)
  const [refreshing, setRefreshing] = useState(false)
  const [pullStartY, setPullStartY] = useState(null)
  const [pullDistance, setPullDistance] = useState(0)
  const feedScrollRef = useRef()
  const [expandedComments, setExpandedComments] = useState({})
  const [commentText, setCommentText] = useState({})
  const [showReactionPicker, setShowReactionPicker] = useState(null)
  const [editingPost, setEditingPost] = useState(null)
  const [editPostText, setEditPostText] = useState('')
  const [lightboxPhoto, setLightboxPhoto] = useState(null)
  const photoInputRef = useRef()

  // Messages state
  const [allMessages, setAllMessages] = useState([])
  const [chatView, setChatView] = useState('inbox') // 'inbox' | 'new' | 'conversation'
  const [selectedRecipient, setSelectedRecipient] = useState(null)
  const [recipientTyping, setRecipientTyping] = useState(false)
  const typingSubRef = useRef(null)

  const normalizedEmail = userEmail.toLowerCase()

  // Total unread count for the Messages tab badge
  const totalUnread = allMessages.filter(m =>
    m.recipient_email?.toLowerCase() === normalizedEmail && !m.read_at
  ).length

  useEffect(() => { getUser(); fetchPosts(); fetchMessages() }, [])

  useEffect(() => {
    if (userEmail && userEmail !== 'local') {
      fetchMessages()
      const feedSub = supabase.channel('feed_posts_ch')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'feed_posts' }, fetchPosts)
        .subscribe()
      const msgSub = supabase.channel('messages_ch')
        .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'messages' }, fetchMessages)
        .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'messages' }, fetchMessages)
        .subscribe()
      return () => {
        supabase.removeChannel(feedSub)
        supabase.removeChannel(msgSub)
      }
    }
  }, [userEmail])

  // Dynamic typing subscription — updates when selected recipient changes
  useEffect(() => {
    if (typingSubRef.current) {
      supabase.removeChannel(typingSubRef.current)
      typingSubRef.current = null
    }
    if (!selectedRecipient || !userEmail || userEmail === 'local') return
    const channelName = `typing_${[userEmail, selectedRecipient.email].sort().join('_')}`
    typingSubRef.current = supabase.channel(channelName)
      .on('broadcast', { event: 'typing' }, ({ payload }) => {
        if (payload.email !== userEmail) {
          setRecipientTyping(true)
          setTimeout(() => setRecipientTyping(false), 3000)
        }
      })
      .subscribe()
    return () => {
      if (typingSubRef.current) supabase.removeChannel(typingSubRef.current)
    }
  }, [selectedRecipient, userEmail])

  useEffect(() => {
    function handle() { setShowReactionPicker(null) }
    document.addEventListener('click', handle)
    return () => document.removeEventListener('click', handle)
  }, [])

  async function getUser() {
    try {
      const cookie = document.cookie.split(';').find(c => c.trim().startsWith('CF_Authorization='))
      if (cookie) {
        const token = cookie.trim().replace('CF_Authorization=', '')
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
        const email = payload.email
        if (email) { localStorage.setItem('bf_user_email', email); setUserEmail(email); return }
      }
    } catch {}
    const cached = localStorage.getItem('bf_user_email')
    setUserEmail(cached || 'local')
  }

  const fetchPosts = useCallback(async () => {
    const { data, error } = await supabase
      .from('feed_posts').select('*, post_reactions(*), post_comments(*)')
      .order('created_at', { ascending: false }).limit(50)
    if (!error) setPosts(data || [])
    setFeedLoading(false)
  }, [])

  async function fetchMessages() {
    const { data, error } = await supabase
      .from('messages').select('*')
      .order('created_at', { ascending: true }).limit(500)
    if (!error) setAllMessages(data || [])
  }

  async function searchGifs(query) {
    if (!query.trim()) { setGifs([]); return }
    setGifLoading(true)
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_KEY}&q=${encodeURIComponent(query)}&limit=20&rating=g`)
      const data = await res.json()
      setGifs(data.data || [])
    } catch { setGifs([]) }
    setGifLoading(false)
  }

  async function loadTrendingGifs() {
    setGifLoading(true)
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${GIPHY_KEY}&limit=20&rating=g`)
      const data = await res.json()
      setGifs(data.data || [])
    } catch { setGifs([]) }
    setGifLoading(false)
  }

  async function pullRefresh() {
    if (refreshing) return
    setRefreshing(true)
    await fetchPosts()
    setRefreshing(false)
    setPullDistance(0)
  }

  function handleFeedTouchStart(e) {
    if (feedScrollRef.current?.scrollTop === 0) setPullStartY(e.touches[0].clientY)
  }
  function handleFeedTouchMove(e) {
    if (pullStartY === null) return
    const dist = e.touches[0].clientY - pullStartY
    if (dist > 0) setPullDistance(Math.min(dist, 80))
  }
  function handleFeedTouchEnd() {
    if (pullDistance > 60) pullRefresh()
    else setPullDistance(0)
    setPullStartY(null)
  }

  async function submitPost() {
    if (!postText.trim() && !postPhoto && !postGif) return
    setPosting(true)
    let photo_url = postGif || null
    if (postPhoto && !postGif) {
      try {
        const ext = postPhoto.name.split('.').pop()
        const path = `social/${Date.now()}.${ext}`
        photo_url = await uploadToR2(postPhoto, path)
      } catch (err) { console.error('Upload failed:', err) }
    }
    await supabase.from('feed_posts').insert([{ user_email: userEmail, content: postText.trim(), photo_url }])
    setPostText(''); setPostPhoto(null); setPostPhotoPreview(null); setPostGif(null); setPosting(false)
    fetchPosts()
  }

  async function saveEditPost(postId) {
    if (!editPostText.trim()) return
    await supabase.from('feed_posts').update({ content: editPostText.trim() }).eq('id', postId)
    setEditingPost(null); setEditPostText(''); fetchPosts()
  }

  async function deletePost(postId) {
    if (!window.confirm('Delete this post? This cannot be undone.')) return
    await supabase.from('post_comments').delete().eq('post_id', postId)
    await supabase.from('post_reactions').delete().eq('post_id', postId)
    await supabase.from('feed_posts').delete().eq('id', postId)
    fetchPosts()
  }

  async function toggleReaction(postId, emoji, e) {
    e?.stopPropagation()
    const post = posts.find(p => p.id === postId)
    const existing = post?.post_reactions?.find(r => r.user_email === userEmail && r.emoji === emoji)
    if (existing) {
      await supabase.from('post_reactions').delete().eq('id', existing.id)
    } else {
      await supabase.from('post_reactions').upsert(
        [{ post_id: postId, user_email: userEmail, emoji }], { onConflict: 'post_id,user_email' }
      )
    }
    setShowReactionPicker(null); fetchPosts()
  }

  async function submitComment(postId) {
    const text = commentText[postId]?.trim()
    if (!text) return
    await supabase.from('post_comments').insert([{ post_id: postId, user_email: userEmail, content: text }])
    setCommentText(prev => ({ ...prev, [postId]: '' })); fetchPosts()
  }

  function openConversation(contact) {
    setSelectedRecipient(contact)
    setChatView('conversation')
    setRecipientTyping(false)
  }

  function backToInbox() {
    setChatView('inbox')
    setSelectedRecipient(null)
    setRecipientTyping(false)
  }

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif', maxWidth: '680px', margin: '0 auto' }}>
      <style>{`
        * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
        input, textarea { font-size: 16px !important; }
        @keyframes typing {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-4px); opacity: 1; }
        }
      `}</style>

      {lightboxPhoto && (
        <div onClick={() => setLightboxPhoto(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.94)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <img src={lightboxPhoto} alt="full" style={{ maxWidth: '100%', maxHeight: '88vh', borderRadius: '10px', objectFit: 'contain' }} />
          <button onClick={() => setLightboxPhoto(null)} style={{ ...S.touchBtn, position: 'absolute', top: 'max(20px,env(safe-area-inset-top,20px))', right: '16px', width: '44px', height: '44px', background: 'rgba(255,255,255,0.18)', borderRadius: '50%', color: 'white', fontSize: '22px' }}>×</button>
        </div>
      )}

      {/* Top tab bar: Feed | Messages */}
      {chatView === 'inbox' || chatView === 'new' || activeTab === 'feed' ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h1 style={S.h1}>{activeTab === 'feed' ? 'Social' : 'Messages'}</h1>
          <div style={{ display: 'flex', background: 'var(--bg-tertiary)', borderRadius: '10px', padding: '3px', gap: '2px' }}>
            {[
              { id: 'feed', label: 'Feed' },
              { id: 'messages', label: 'Messages', badge: totalUnread },
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); if (tab.id === 'messages') setChatView('inbox') }}
                style={{ ...S.touchBtn, minHeight: '36px', padding: '0 16px', borderRadius: '8px', fontSize: '14px', fontWeight: '600', gap: '5px', background: activeTab === tab.id ? 'var(--bg-card)' : 'transparent', color: activeTab === tab.id ? 'var(--text-primary)' : 'var(--text-tertiary)', boxShadow: activeTab === tab.id ? '0 1px 3px rgba(0,0,0,0.12)' : 'none' }}
              >
                {tab.label}
                {tab.badge > 0 && <span style={{ background: '#e94560', color: 'white', borderRadius: '10px', fontSize: '11px', fontWeight: '700', padding: '1px 6px' }}>{tab.badge}</span>}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      {/* GIF Picker for feed */}
      {showGifPicker === 'post' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }} onClick={() => setShowGifPicker(null)}>
          <div style={{ background: 'var(--bg-card)', borderRadius: '20px 20px 0 0', width: '100%', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div style={{ padding: '16px 16px 10px', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input placeholder="Search GIFs..." value={gifSearch} onChange={e => { setGifSearch(e.target.value); searchGifs(e.target.value) }} style={{ ...S.input, flex: 1 }} autoFocus />
              <button onClick={() => setShowGifPicker(null)} style={{ ...S.touchBtn, width: '36px', height: '36px', minWidth: '36px', background: 'var(--bg-tertiary)', borderRadius: '50%', fontSize: '18px', color: 'var(--text-secondary)' }}>×</button>
            </div>
            <div style={{ overflowY: 'auto', padding: '10px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
              {gifLoading && <p style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text-tertiary)', padding: '20px' }}>Loading...</p>}
              {!gifLoading && gifs.length === 0 && <p style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--text-tertiary)', padding: '20px' }}>No GIFs found</p>}
              {gifs.map(gif => (
                <img key={gif.id} src={gif.images.fixed_height_small.url} alt={gif.title}
                  onClick={() => { setPostGif(gif.images.downsized.url); setPostPhoto(null); setPostPhotoPreview(null); setShowGifPicker(null) }}
                  style={{ width: '100%', borderRadius: '8px', cursor: 'pointer', aspectRatio: '4/3', objectFit: 'cover' }}
                />
              ))}
            </div>
            <p style={{ textAlign: 'center', fontSize: '11px', color: '#c7c7cc', padding: '8px', borderTop: '1px solid var(--border-light)' }}>Powered by GIPHY</p>
          </div>
        </div>
      )}

      {/* FEED */}
      {activeTab === 'feed' && (
        <div>
          <div style={{ ...S.card, padding: '14px' }}>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
              <MemberAvatar email={userEmail} size={40} />
              <textarea placeholder="What's on your mind?" value={postText} onChange={e => setPostText(e.target.value)} rows={3} style={S.textarea} />
            </div>
            {postPhotoPreview && (
              <div style={{ position: 'relative', marginBottom: '10px', display: 'inline-block' }}>
                <img src={postPhotoPreview} alt="preview" style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '10px', objectFit: 'cover', display: 'block' }} />
                <button onClick={() => { setPostPhoto(null); setPostPhotoPreview(null) }} style={{ ...S.touchBtn, position: 'absolute', top: '6px', right: '6px', width: '32px', height: '32px', minWidth: '32px', minHeight: '32px', background: 'rgba(0,0,0,0.55)', borderRadius: '50%', color: 'white', fontSize: '18px' }}>×</button>
              </div>
            )}
            {postGif && (
              <div style={{ position: 'relative', marginBottom: '10px', display: 'inline-block' }}>
                <img src={postGif} alt="gif" style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '10px', display: 'block' }} />
                <button onClick={() => setPostGif(null)} style={{ ...S.touchBtn, position: 'absolute', top: '6px', right: '6px', width: '32px', height: '32px', minWidth: '32px', minHeight: '32px', background: 'rgba(0,0,0,0.55)', borderRadius: '50%', color: 'white', fontSize: '18px' }}>×</button>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: '4px' }}>
                <button onClick={() => photoInputRef.current.click()} style={{ ...S.touchBtn, gap: '4px', fontSize: '14px', color: 'var(--text-tertiary)', fontWeight: '500', padding: '0 4px' }}>📷</button>
                <input ref={photoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => { const f = e.target.files[0]; if (f) { setPostPhoto(f); setPostPhotoPreview(URL.createObjectURL(f)); setPostGif(null) } }} />
                <button onClick={() => { setShowGifPicker('post'); loadTrendingGifs(); setGifSearch('') }} style={{ ...S.touchBtn, gap: '4px', fontSize: '13px', color: 'var(--text-tertiary)', fontWeight: '600', padding: '0 4px' }}>GIF</button>
              </div>
              <button onClick={submitPost} disabled={posting || (!postText.trim() && !postPhoto && !postGif)} style={{ ...S.touchBtn, minHeight: '42px', minWidth: 'unset', padding: '0 22px', borderRadius: '22px', fontWeight: '700', fontSize: '15px', background: posting || (!postText.trim() && !postPhoto && !postGif) ? '#c7c7cc' : '#e94560', color: 'white' }}>{posting ? 'Posting...' : 'Post'}</button>
            </div>
          </div>

          {pullDistance > 10 && (
            <div style={{ textAlign: 'center', padding: '8px 0', fontSize: '13px', color: 'var(--text-tertiary)' }}>
              {pullDistance > 60 ? '↑ Release to refresh' : '↓ Pull to refresh'}
            </div>
          )}
          {refreshing && <div style={{ textAlign: 'center', padding: '10px 0', fontSize: '13px', color: 'var(--text-tertiary)' }}>Refreshing...</div>}

          <div ref={feedScrollRef} onTouchStart={handleFeedTouchStart} onTouchMove={handleFeedTouchMove} onTouchEnd={handleFeedTouchEnd}>
            {feedLoading ? (
              <><PostSkeleton /><PostSkeleton /><PostSkeleton /></>
            ) : posts.length === 0 ? (
              <div style={{ ...S.card, padding: '48px 24px', textAlign: 'center' }}>
                <p style={{ fontSize: '44px', marginBottom: '10px' }}>📣</p>
                <p style={{ fontSize: '17px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>Nothing posted yet</p>
                <p style={{ fontSize: '14px', color: 'var(--text-tertiary)' }}>Be the first to share something</p>
              </div>
            ) : (
              <>
                {posts.map(post => {
                  const myReaction = post.post_reactions?.find(r => r.user_email === userEmail)
                  const reactionGroups = (post.post_reactions || []).reduce((acc, r) => { acc[r.emoji] = (acc[r.emoji] || 0) + 1; return acc }, {})
                  const isOwn = post.user_email?.toLowerCase() === normalizedEmail
                  const commentsOpen = expandedComments[post.id]
                  const isEditing = editingPost === post.id
                  return (
                    <div key={post.id} style={S.card}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 14px 0' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <MemberAvatar email={post.user_email} size={40} />
                          <div>
                            <p style={{ fontSize: '15px', fontWeight: '600', color: 'var(--text-primary)', margin: 0 }}>{displayName(post.user_email)}</p>
                            <p style={{ ...S.caption, margin: 0 }}>{timeAgo(post.created_at)}</p>
                          </div>
                        </div>
                        {isOwn && !isEditing && (
                          <div style={{ display: 'flex' }}>
                            <button onClick={() => { setEditingPost(post.id); setEditPostText(post.content || '') }} style={{ ...S.touchBtn, fontSize: '14px', color: 'var(--text-tertiary)', padding: '0 8px' }}>Edit</button>
                            <button onClick={() => deletePost(post.id)} style={{ ...S.touchBtn, fontSize: '14px', color: '#c7c7cc', padding: '0 8px' }}>Delete</button>
                          </div>
                        )}
                      </div>
                      {isEditing ? (
                        <div style={{ padding: '12px 14px' }}>
                          <textarea value={editPostText} onChange={e => setEditPostText(e.target.value)} rows={3} autoFocus style={{ ...S.textarea, border: '1.5px solid #e94560', background: 'var(--bg-card)' }} />
                          <div style={{ display: 'flex', gap: '8px', marginTop: '10px', justifyContent: 'flex-end' }}>
                            <button onClick={() => setEditingPost(null)} style={{ ...S.touchBtn, minWidth: 'unset', padding: '0 16px', borderRadius: '10px', background: 'var(--bg-tertiary)', fontSize: '15px', color: 'var(--text-secondary)' }}>Cancel</button>
                            <button onClick={() => saveEditPost(post.id)} style={{ ...S.touchBtn, minWidth: 'unset', padding: '0 16px', borderRadius: '10px', background: '#e94560', fontSize: '15px', fontWeight: '600', color: 'white' }}>Save</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          {post.content && <p style={{ ...S.body, padding: '10px 14px 12px', margin: 0 }}>{post.content}</p>}
                          {post.photo_url && <img src={post.photo_url} alt="post" onClick={() => setLightboxPhoto(post.photo_url)} style={{ width: '100%', maxHeight: '420px', objectFit: 'cover', display: 'block', cursor: 'pointer' }} />}
                        </>
                      )}
                      {Object.keys(reactionGroups).length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '10px 14px 2px' }}>
                          {Object.entries(reactionGroups).map(([emoji, count]) => (
                            <button key={emoji} onClick={e => toggleReaction(post.id, emoji, e)} style={{ ...S.touchBtn, minHeight: '34px', minWidth: 'unset', padding: '0 10px', borderRadius: '20px', fontSize: '13px', fontWeight: '600', color: 'var(--text-primary)', background: myReaction?.emoji === emoji ? '#fff0f2' : 'var(--bg-tertiary)', border: myReaction?.emoji === emoji ? '1.5px solid #e94560' : '1.5px solid transparent' }}>{emoji} {count}</button>
                          ))}
                        </div>
                      )}
                      <div style={{ display: 'flex', borderTop: '1px solid var(--border-light)', marginTop: '8px', position: 'relative' }}>
                        <button onClick={e => { e.stopPropagation(); setShowReactionPicker(showReactionPicker === post.id ? null : post.id) }} style={{ ...S.touchBtn, flex: 1, fontSize: '14px', color: 'var(--text-tertiary)', fontWeight: '500', gap: '5px' }}>😊 React</button>
                        <div style={{ width: '1px', background: 'var(--bg-tertiary)', margin: '8px 0' }} />
                        <button onClick={() => setExpandedComments(prev => ({ ...prev, [post.id]: !prev[post.id] }))} style={{ ...S.touchBtn, flex: 1, fontSize: '14px', color: 'var(--text-tertiary)', fontWeight: '500', gap: '5px' }}>💬 {post.post_comments?.length || 0}</button>
                        {showReactionPicker === post.id && (
                          <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', bottom: '54px', left: '8px', right: '8px', background: 'var(--bg-card)', borderRadius: '16px', padding: '12px', boxShadow: '0 6px 28px rgba(0,0,0,0.18)', display: 'flex', flexWrap: 'wrap', gap: '2px', zIndex: 200 }}>
                            {REACTION_EMOJIS.map(emoji => (
                              <button key={emoji} onClick={e => toggleReaction(post.id, emoji, e)} style={{ ...S.touchBtn, width: '44px', height: '44px', minWidth: '44px', fontSize: '24px', borderRadius: '10px' }}>{emoji}</button>
                            ))}
                          </div>
                        )}
                      </div>
                      {commentsOpen && (
                        <div style={{ padding: '4px 14px 14px', borderTop: '1px solid #f9f9f9' }}>
                          {(post.post_comments || []).length === 0 && <p style={{ ...S.caption, padding: '10px 0 6px', fontSize: '13px' }}>No comments yet.</p>}
                          {(post.post_comments || []).sort((a, b) => new Date(a.created_at) - new Date(b.created_at)).map(c => (
                            <div key={c.id} style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                              <MemberAvatar email={c.user_email} size={30} />
                              <div style={{ background: 'var(--bg-tertiary)', borderRadius: '14px', padding: '8px 12px', flex: 1 }}>
                                <p style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '2px', margin: '0 0 2px' }}>{displayName(c.user_email)}</p>
                                <p style={{ fontSize: '15px', color: 'var(--text-primary)', lineHeight: 1.4, margin: 0 }}>{c.content}</p>
                              </div>
                            </div>
                          ))}
                          <div style={{ display: 'flex', gap: '8px', marginTop: '12px', alignItems: 'center' }}>
                            <input placeholder="Write a comment..." value={commentText[post.id] || ''} onChange={e => setCommentText(prev => ({ ...prev, [post.id]: e.target.value }))} onKeyDown={e => e.key === 'Enter' && submitComment(post.id)} style={{ ...S.input, flex: 1 }} />
                            <button onClick={() => submitComment(post.id)} style={{ ...S.touchBtn, width: '44px', height: '44px', minWidth: '44px', borderRadius: '50%', background: '#e94560', color: 'white', fontSize: '20px' }}>↑</button>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
                <p style={{ textAlign: 'center', ...S.caption, padding: '16px 0 8px', fontSize: '13px' }}>You're all caught up</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* MESSAGES */}
      {activeTab === 'messages' && chatView === 'inbox' && (
        <MessagesInbox
          userEmail={userEmail}
          allMessages={allMessages}
          onSelectContact={openConversation}
          onNewMessage={() => setChatView('new')}
        />
      )}

      {activeTab === 'messages' && chatView === 'new' && (
        <NewMessagePicker
          userEmail={userEmail}
          onSelect={openConversation}
          onBack={() => setChatView('inbox')}
        />
      )}

      {activeTab === 'messages' && chatView === 'conversation' && selectedRecipient && (
        <ConversationView
          userEmail={userEmail}
          recipient={selectedRecipient}
          allMessages={allMessages}
          onBack={backToInbox}
          onFetchMessages={fetchMessages}
          recipientTyping={recipientTyping}
        />
      )}
    </div>
  )
}
